import type { TourStep } from "@shared/lib/walkthrough/types";

export const tourSteps: TourStep[] = [
  {
    target: "children-glance",
    title: "Your Children",
    description:
      "Tap any child to see their profile, health info, and attendance history. The ring color shows their check-in status.",
  },
  {
    target: "activity-feed",
    title: "Today's Moments",
    description:
      "A live feed of your children's day -- meals, naps, photos, and activities logged by their teachers.",
  },
  {
    target: "qr-checkin",
    title: "QR Check-In",
    description:
      "Tap here to open the scanner for quick drop-off and pickup at your center.",
  },
  {
    target: "tab-messages",
    title: "Messages",
    description:
      "Chat with your children's teachers. A red dot appears when you have unread messages.",
  },
  {
    target: "tab-bar",
    title: "Navigation",
    description:
      "Switch between Home, Messages, Billing, and Profile using the bottom tabs.",
  },
];
